import { IconWithText } from "../styles/components";
import ErrorIcon from '@mui/icons-material/Error';

function IncompleteAddressError() {
    return <IconWithText centered><ErrorIcon color='error' fontSize='small'></ErrorIcon> <span style={{color: 'red'}}>Incomplete address</span></IconWithText>;
}

export default IncompleteAddressError;